import React from 'react';
import PropTypes from 'prop-types';
import {CSSTransition} from 'react-transition-group';

// At the moment this just supports a single message at a time.
class FadingMessage extends React.PureComponent {

	constructor(props) {
		super(props);
		this.state = {
			currentMessage: undefined,
			timeout: undefined,
			expired: undefined
		};
		this.clearMessage = this.clearMessage.bind(this);
	}

	static propTypes = {
		message: PropTypes.shape({
			text: PropTypes.string.required,
			type: PropTypes.string.required
		}),
		timeout: PropTypes.number
	};

	static defaultProps = {
		timeout: 4000
	};

	static getDerivedStateFromProps(props, state) {
		if (props.message !== undefined && props.message !== state.currentMessage) {
			clearTimeout(state.timeout);
			const currentMessage = props.message;
			const messageClass = ( currentMessage === undefined ? "message" : `message-${currentMessage.type}` );
			const timeout = undefined;
			const expired = false;
			return {currentMessage, messageClass, timeout, expired};
		}
		return null;
	}

	componentDidUpdate(props, state) {
		if (this.state.currentMessage !== undefined && this.state.timeout === undefined && this.state.expired === false) {
			const timeout = setTimeout(this.clearMessage, this.props.timeout);
			this.setState({timeout});
		}
	}

	clearMessage() {
		console.log(`Clearing fading message after timeout: ${JSON.stringify(this.state.currentMessage)}`)
		this.setState({expired: true, timeout: undefined});
	}

	render() {
		return <CSSTransition
			in={this.shouldShow()}
			timeout={500} classNames="fade"
			unmountOnExit={true}
		>
			{(state) => (
				<div className={this.state.messageClass}>{this.currentMessage !== null ? this.state.currentMessage.text : ""}</div>
			)}
		</CSSTransition>;
	}

	shouldShow() {
		return this.state.currentMessage !== undefined && this.state.expired === false
	}
}

export default FadingMessage;



// WEBPACK FOOTER //
// ./src/components/FadingMessage.js